import { FormattedPriceCalculationResponse } from '@atlassiansox/bxp-use-pricing';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { UserTier } from '../../user-tier';
import { CenterJustifiedContainer } from './center-justified-container';
import { PriceDisplay } from './price-display';

export type AnnualProps = {
  readonly priceCalc: FormattedPriceCalculationResponse;
  readonly fontSize: string;
  readonly planName: string;
};

export const Annual = ({ priceCalc, fontSize, planName }: AnnualProps) => (
  <>
    <PriceDisplay
      planName={planName}
      formattedPrice={priceCalc.formattedTotalPrice}
      fontSize={fontSize}
    />
    <CenterJustifiedContainer>
      <PriceDesc>
        <FormattedMessage
          id="pricingDescMessageAnnual"
          defaultMessage="per year"
          description="Annual total price description"
        />
      </PriceDesc>
      <UserTierContainer>
        <UserTier priceCalc={priceCalc} />
      </UserTierContainer>
    </CenterJustifiedContainer>
  </>
);

const PriceDesc = styled.div`
  font-size: 16px;
  line-height: 24px;
`;

const UserTierContainer = styled.div`
  margin: 15px 0 32px;
`;
